<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card border-variant="primary">
          <template slot="header">
            <i class='fa fa-align-justify'></i> Agent Install history
          </template>
          <!-- detail search start -->
          <b-card v-show="so.adv">
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="opt_date"> Installed_at
                  <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('w')">W</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('m')">M</b-button>
                </label>
                <b-form inline>
                  <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                  ~
                  <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                </b-form>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="opt_date"> Deleted_at
                  <b-button size="sm" variant="info" @click="set_sd('', 'deleted_at')"><i class="fa fa-remove"></i></b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1d', 'deleted_at')">-1D</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1w', 'deleted_at')">-1W</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('-1m', 'deleted_at')">-1M</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('w', 'deleted_at')">W</b-button>
                  <b-button size="sm" variant="primary" @click="set_sd('m', 'deleted_at')">M</b-button>
                </label>
                <b-form inline>
                  <date-picker @change="refresh" v-model="so.opt.deleted_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                  ~
                  <date-picker @change="refresh" v-model="so.opt.deleted_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                </b-form>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="opt_group">Status</label>
                <br>
                <select v-model="so.opt['is_del']" @change="refresh">
                  <option disabled value="">Please select Success or Failed</option>
                  <option value="true">Deleted</option>
                  <option value="false">Alive</option>
                </select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <label for="opt_group">Status</label>
              <br>
              <select v-model="so.opt['type']" @change="$refs._list.refresh()">
                <option disabled value="">Please select status</option>
                <option value="WAF">WAF</option>
                <option value="WSFinder">WSFinder</option>
                <option value="WMDS">WMDS</option>
              </select>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="opt_user_reason">Reason</label>
                <b-form-input @keydown.enter="refresh" type="text" id="opt_user_reason" v-model="so.opt['reason']"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row>
            <b-col md="12">
              <label for="ph_search_opt_type">Match Type</label>
              <b-form-group>
                <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                  <b-form-radio value="and">[AND]:Match all</b-form-radio>
                  <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group class="float-right">
            <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
            <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
            <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
          </b-form-group>
        </b-card>
        <!-- detail search end -->
        <hr>
          <b-row>
            <b-col sm="2">
              <!-- <b-badge variant="primary">
                TOTAL : {{summaryData.good + summaryData.bad}}
              </b-badge>
              <br>
              <b-badge variant="success">
                GOOD : {{summaryData.good}}
              </b-badge>
              <br>
              <b-badge variant="danger">
                BAD : {{summaryData.bad}}
              </b-badge> -->
            </b-col>
            <b-col sm="10" class="md-10">
              <b-input-group size="sm">
                <b-input-group-prepend>
                  <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
                  <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
                  <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                    <b-dropdown-item size="sm" @click="so.sk='type';so.skt='Solution'; so.sv = ''">Solution</b-dropdown-item>
                    <b-dropdown-item size="sm" @click="so.sk='is_del';so.skt='Status'; so.sv = ''">Status</b-dropdown-item>
                  </b-dropdown>
                  <select :disabled="so.adv" v-model="so.sv" v-if="so.sk == 'type'" @change="$refs._list.refresh()">
                    <option disabled value="">Please select status</option>
                    <option value="WAF">WAF</option>
                    <option value="WSFinder">WSFinder</option>
                    <option value="WMDS">WMDS</option>
                  </select>
                  <select :disabled="so.adv" v-model="so.sv" v-if="so.sk == 'is_del'" @change="$refs._list.refresh()">
                    <option disabled value="">Please select status</option>
                    <option value="true">Deleted</option>
                    <option value="false">Alive</option>
                  </select>
                </b-input-group-prepend>
                <b-form-input :disabled="so.adv" v-if="so.sk != 'is_del' && so.skt != 'Solution'" v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
                <b-input-group-append>
                  <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
                  <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
                </b-input-group-append>
              </b-input-group>
              <br>
              <b-input-group size="sm">
                <select v-model="so.perPage" @change="refresh" style="margin-right:15px">
                    <option disabled value="15">Show count : Default 15</option>
                    <option value=10>10</option>
                    <option value=50>50</option>
                    <option value=100>100</option>
                  </select>

                  <select v-if="sync.enable" v-model="sync.interval" @change="refresh" style="margin-right:15px">
                    <option disabled value="15">Please select interval : Default 15</option>
                    <option value=10>10</option>
                    <option value=30>30</option>
                    <option value=60>60</option>
                    <option value=300>300(5 min)</option>
                  </select>
                  <span v-if="sync.enable" class="float-right" style="margin-right:15px">
                    <i :class="`fa fa-refresh ${sync.th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
                    <b-btn @click="pause" size="sm" variant="warning">
                      {{!sync.stop ? "Auto refresh"  : "Pause"}}
                    </b-btn>
                  </span>
                  <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">Hide deleted</b-checkbox>
              </b-input-group>
            </b-col>
          </b-row>
          <hr>
          <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
            <template slot="created_at" slot-scope="row">{{ row.item.created_at | datetime }}</template>
            <template slot="deleted_at" slot-scope="row">{{ row.item.deleted_at | datetime }}</template>
            <template slot="type" slot-scope="row">
              <b-badge v-if="!row.item.is_del" variant="success">
                {{row.item.type}}
              </b-badge>
              <span v-else>
                <del>{{row.item.type}}</del>
              </span>
            </template>
            <template slot="agent" slot-scope="row">
              <b-btn @click="detail_agent(row.item)" size="sm" variant="outline-primary">More</b-btn>
            </template>
            <template slot="service" slot-scope="row">
              <b-btn @click="detail_service(row.item)" size="sm" variant="outline-primary">More</b-btn>
            </template>
            <template slot="group" slot-scope="row">
              <b-btn @click="detail_group(row.item)" size="sm" variant="outline-primary">More</b-btn>
            </template>
          </b-table>
          <hr>
          <b-row>
            <b-col class="md-8">
              <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Group info"  class="modal-info" v-model="modal_group" @ok="modal_group = false" ok-variant="info" ok-only>
      <table class="table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Info</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Group Name</td>
            <td>{{modal_group_info.groupname}}</td>
          </tr>
          <tr>
            <td>Joined_at</td>
            <td>{{modal_group_info.created_at | sdate}}</td>
          </tr>
          <tr>
            <td>Now Plan</td>
            <td>{{modal_group_info.service}}</td>
          </tr>
          <tr>
            <td>User</td>
            <td>{{modal_group_info.count}} users</td>
          </tr>
        </tbody>
      </table>
      <!-- {{modal_group_info}} -->
    </b-modal>
    <b-modal title="Agent info"  class="modal-dark" v-model="modal_agent" @ok="modal_agent = false" ok-variant="dark" ok-only>
      <table class="table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Info</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Agent Name</td>
            <td>{{modal_agent_info.name}}</td>
          </tr>
          <tr>
            <td>{{modal_agent_info.fqdn ? 'FQDN' : 'Version'}}</td>
            <td>{{modal_agent_info.fqdn ? modal_agent_info.fqdn : modal_agent_info.version}}</td>
          </tr>
          <tr>
            <td>OS</td>
            <td>{{modal_agent_info.os_type ? modal_agent_info.os_type : '-'}}</td>
          </tr>
        </tbody>
      </table>
    </b-modal>
    <b-modal title="Service Info"  class="modal-info" v-model="modal_service" @ok="modal_service = false" ok-variant="primary" ok-only>
      <table class="table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Info</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Service When Install</td>
            <td>{{modal_service_info.service_name}}</td>
          </tr>
          <tr>
            <td>Joined_at</td>
            <td>{{modal_service_info.created_at | sdate}}</td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import { Api } from '@/service';
import codes from '@/codes';


// const default_opt = () => ({
//   perPage: 15,
//   currentPage: 1, totalRows: 0,
//   sk: '', sv: '', skt: 'reason', opt : {}, adv: false
// });

// props explain
// auto_refresh[default=false] : auth sync enable or disable, value is boolean
// user : this component to user list, using by user dependency

export default {
  name : "InstallList",
  props: ['user', 'auto_refresh'],
  components: { DatePicker },
  data: () => ({
    hide_del : true,
    modal_service : false,
    modal_agent : false,
    modal_group : false,
    modal_service_info : {},
    modal_agent_info : {},
    modal_group_info : {},
    custom,
    so : Object.assign({}, codes.search_opt, { skt : '' }),
    sync : { interval : 15, stop : false, th : undefined, enable : false },
    summaryData : { good : 0, bad : 0 },
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      let f = [
        { key: 'created_at', sortable: true, label: 'Installed_at' },
        { key: 'deleted_at', sortable: true, label: 'Deleted_at' },
        { key: 'type', sortable: true, label: 'Solution'},
        // { key: 'reason', sortable: false, label: 'Reason'},
        { key: 'agent', sortable: false, label: 'Agent' },
        { key: 'group', sortable: false, label: 'Group' },
        { key: 'service', sortable: false, label: 'Service' },
      ]
      return this.user ? f.splice(0, 4) : f
    }
  },
  methods: {
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.opt['is_del'] = 'false';
        this.so.opt['type'] = ''
        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }
      if(k == 'type') {
        return { name : k, value : v, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt, opt);
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th && this.sync.stop) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    refresh() {
      console.log("refresh", this.$route.name, new Date());
      if(this.$refs._list) {
        this.$refs._list.refresh();
        if(this.sync.enable) {
          this.sync.stop = false; this.pause();
        }
      }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      let so = {
        target : 'agent.history', cmd : 'list',
        body : { sort : [{ name : 'is_del',op : 'asc' }, { name : "id", op : "desc" }], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * this.so.perPage, limit: this.so.perPage, // 10 은 나중에 변수 처리해야함.
      }
      // if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.user) { so.body.and.push({ name : 'group_id', value : this.user.id, op : '=' }) }
      if( this.so.sv && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)) }
      if(this.hide_del) { so.body.and.push({ name : 'is_del', value : false, op : '=' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_del':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.warn("start created_at is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.warn("end created_at is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'deleted_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.warn("start deleted_at is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'deleted_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.warn("end deleted_at is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return Api.Partner(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail_group: function(item) {
      console.info(item);
      Api.Partner_Call('group','detail',{ id : item.group_id })
        .then(rs => {
          this.modal_group_info = rs.body
          // this.modal_group_info = Object.assign({}, this.modal_group_info, rs.body)
          this.modal_group = true
        })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail_service: function(item) {
      console.info(item);
      Api.Partner_Call('partner.license','detail',{ id : item.service_id })
        .then(rs => {
          this.modal_service_info = rs.body
          // this.modal_service_info = Object.assign({}, this.modal_service_info, rs.body)
          this.modal_service = true
        })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail_agent: function(item) {
      console.info(item);
      Api.Partner_Call('agent.history','info',{ id : item.agent_id, type : item.type })
        .then(rs => {
          this.modal_agent_info = rs.body
          // this.modal_agent_info = Object.assign({}, this.modal_agent_info, rs.body)
          this.modal_agent = true
        })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail: function(item) { console.info(item); this.$router.push(`/log/install/${item.id}`); },
    // summary() {
    //   let and = [];
    //   let id = undefined;
    //   if(this.user) { id = this.user.id; and.push({ name : 'user_id', value : id, op : '='}) }
    //   Api.Partner({ target : 'log.login', cmd : 'summary.user', body : { and : and, or : [], sort : [] } })
    //     .then(rs => { this.summaryData = Object.assign(this.summaryData, rs.body) })
    //     .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    // },
  },
  created() { console.log('log.install.vue', 'created'); },
  destroyed() { console.log('log.install.vue', 'destroyed'); },
  mounted() {
    console.log('log.install.vue', 'mounted');
    if(this.auto_refresh == true) { this.sync.enable = this.auto_refresh; }
    if(this.user) {
      this.so.sk = 'addr'
      this.so.skt = 'Address'
    }
    setTimeout(this.summary, 1000)
  },
}
</script>
